import { render, staticRenderFns } from "./InvMoveView.vue?vue&type=template&id=700e4afd&scoped=true&"
import script from "./InvMoveView.vue?vue&type=script&lang=js&"
export * from "./InvMoveView.vue?vue&type=script&lang=js&"
import style0 from "./InvMoveView.vue?vue&type=style&index=0&id=700e4afd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e4afd",
  null
  
)

export default component.exports